import { TICKET } from 'conversations-message-history/crm-object-lifecycle-update/constants/objectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getObjectType } from 'conversations-message-history/crm-object-lifecycle-update/operators/crmObjectLifecycleUpdateGetters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isTicketCreatedType } from 'conversations-message-history/crm-object-lifecycle-update/operators/isTicketCreatedType';
import ThreadCrmTicketCreatedTile from '../crm-ticket-lifecycle-update/ThreadCrmTicketCreatedTile';
// import ThreadCrmTicketCreatedTile from '../crm-ticket-lifecycle-update/ThreadCrmTicketCreatedTile';
import ThreadCrmTicketUpdateLabel from '../crm-ticket-lifecycle-update/ThreadCrmTicketUpdateLabel';
// import ThreadCrmTicketUpdateLabel from '../crm-ticket-lifecycle-update/ThreadCrmTicketUpdateLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectLifecycleUpdateSystemMessage = ({
  message,
  onTicketLinkClick,
  portalId,
  senders,
  userId,
  ungatedForThreadMessagesUIImprovements
}) => {
  const objectType = getObjectType(message);
  if (objectType === TICKET) {
    if (isTicketCreatedType(message)) {
      return /*#__PURE__*/_jsx(ThreadCrmTicketCreatedTile, {
        message: message,
        portalId: portalId,
        senders: senders,
        userId: userId,
        ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
      });
    }
    return /*#__PURE__*/_jsx(ThreadCrmTicketUpdateLabel, {
      message: message,
      onTicketLinkClick: onTicketLinkClick,
      portalId: portalId,
      senders: senders,
      userId: userId,
      ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
    });
  }
  return null;
};
CrmObjectLifecycleUpdateSystemMessage.displayName = 'CrmObjectLifecycleUpdateSystemMessage';
export default CrmObjectLifecycleUpdateSystemMessage;